'use strict';
import $ from 'jquery';
import Mustache from 'mustache';
import * as cart from '../api/cart';
import { updateHeaderCart } from './header-cart';
import alert from '../ui/alert';
import stickyCta from '../ui/sticky-cta';
import { GoogleTagManager } from '../misc/ga-events';

/* global GoogleTagManager */

export default function checkoutCart() {
	const $container = $('.checkout-cart');
	if (!$container.length) return false;

	const templates = {
		cart: $('#mustache-cart').html(),
		item: $('#mustache-cart-item').html(),
	};

	const showMessage = alert($container);
	const setReviewOnly = (items) =>
		items.forEach((item) => (item.review = true));
	const renderPrice = () => (text, render) =>
		render(text).replace('.', ',') + '&nbsp;&euro;';

	let sticky_cta = stickyCta('.sticky-cta');

	// Change buy products CTA URL parameter based on selected buyer role
	$('.checkout-cart').on('change', 'input[name="buyerrole"]', function () {
		const $this = $(this);
		const $buyCta = $('#buy-products-cta');
		const $buyCtaHref = $buyCta.attr('href');
		if ($buyCtaHref.indexOf('br=') === -1) {
			$buyCta.attr('href', $buyCtaHref + '?br=' + $this.val());
		} else {
			const newUrl = $buyCtaHref.replace(/br=[^&]*/, 'br=' + $this.val());
			$buyCta.attr('href', newUrl);
		}
	});

	/**
	 * @param  {Object} data
	 * @return {jQuery}
	 */
	const renderCart = (data, customCta) => {
		setReviewOnly(data.expiredItems);
		if ($container.hasClass('review')) {
			data.checkout = true;
			setReviewOnly(data.reservedItems);
		}
		data.oneItemOnly = data.reservedItems.length === 1 ? 1 : 0;
		data.renderPrice = renderPrice;
		data.reservedItems.forEach((item) => (item.renderPrice = renderPrice));
		const markup = Mustache.render(templates.cart, $.extend({}, data), {
			item: templates.item,
		});
		const visibleMessages = {};
		$container.find('.alert').each(function () {
			visibleMessages[$(this).text().trim()] = $(this);
		});

		$container.html(markup).removeClass('stage-markup');
		$('.cart-items-count').html(data.totals.amount);
		const messages = [].concat.call(
			[],
			$container.data('messages') || [],
			data.messages || []
		);
		if (messages && messages.length) {
			messages
				.filter((message) => !visibleMessages[message.message])
				.forEach(showMessage);
		}

		if (sticky_cta) sticky_cta.reinit('.sticky-cta');
		if (customCta) customCta.reinit('.sticky-cta');
	};

	/**
	 * @param  {jQuery} $el
	 * @param  {Promise} action
	 * @return {Promise}
	 */
	const cartAction = ($el, action, cta) => {
		$el.addClass('loading');
		return action
			.tap((res) => {
				const data = res.cart || {};
				if (res.messages) {
					[].push.apply(data.messages, res.messages);
				}

				// Get buyer role from the fieldset before rendering the cart
				// and set it to data object
				const userCookie = document.cookie
					.split('; ')
					.find(row => row.startsWith('user='));
				let userData = {};
				if (userCookie) {
					const userValue = userCookie.split('=')[1];
					userData = JSON.parse(decodeURIComponent(userValue));
					data.isLoggedIn = userData.loggedIn && window.location.href.indexOf('ostoskori') !== -1;
				} else {
					data.isLoggedIn = false;
				}
				const buyerRole = $el.find('input[name="buyerrole"]:checked').val();
				data.isCompany = buyerRole && buyerRole === 'c' ? true : false;
				data.isRetail = buyerRole && buyerRole === 'r' ? true : false;

				renderCart($.extend({}, data), cta);
				if ($('.js-header-carts').length) {
					updateHeaderCart(false, res.cart);
				}
			})
			.finally(() => $el.removeClass('loading'));
	};

	if (!$container.hasClass('stage-markup')) {
		// load cart with ajax if it wasn't rendered on server
		cartAction($container, cart.getCart());
	} else {
		// display messages otherwise
		const messages = $container.data('messages');
		if (messages && messages.length) {
			messages.forEach((msg) => {
				showMessage(msg);
				if (msg.kind === 'unavailable' && msg.itemId) {
					cart.removeItem(msg.itemId);
				}
			});
		}
	}

	$container.on('cartaction', (e, action, cta) => {
		cartAction($container, action, cta);
	});

	$container.on('change', '.item-amount-selector', function () {
		const $item = $(this).closest('.cart-item');
		const itemId = $item.data('id');
		const amount = $(this).val();
		return cartAction($container, cart.updateItemAmount(itemId, amount));
	});

	$container.on('click', '.item-remove', function (e) {
		e.preventDefault();
		let $item = $(this).closest('.cart-item');
		if (!$item.length) {
			$item = $(this.closest('.product-list-item'));
		}

		const itemId = $item.data('item-id') || $item.data('id');

		const promise = cart.removeItem(itemId).then((res) => {
			const itemAmount = parseInt(
				$item.find('.item-amount .item-amount-selector').val()
			);
			$item.find('.item-product').each(function () {
				const data = $(this).data();
				const quantity = parseInt(data.amount) * itemAmount;

				GoogleTagManager.removeFromCart(
					data.id,
					data.ean.toString(),
					quantity,
					data.color,
					data.name,
					data.brand,
					data.categoryPath,
					data.sports,
					data.targetgroup,
					data.fullCategoryPath,
					data.salesPrice,
					data.saleProduct
				);
			});
			return res;
		});

		return cartAction($container, promise);
	});

	$container.on('click', '.item-reserve', function () {
		const $item = $(this).closest('.cart-item');
		const itemId = $item.data('id');
		return cartAction($container, cart.reserveItem(itemId));
	});

	$container.on('click', '.expired-items-reserve', () => {
		return cartAction($container, cart.reserveExpiredItems());
	});

	$container.on('click', '.expired-items-clear', () => {
		return cartAction($container, cart.removeExpiredItems());
	});
}
